import { render, staticRenderFns } from "./LayoutStructureOdonto.vue?vue&type=template&id=5affaa3c&scoped=true"
import script from "./LayoutStructureOdonto.vue?vue&type=script&lang=js"
export * from "./LayoutStructureOdonto.vue?vue&type=script&lang=js"
import style0 from "./LayoutStructureOdonto.vue?vue&type=style&index=0&id=5affaa3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5affaa3c",
  null
  
)

export default component.exports